/**
 * Vincent B796 (Eric 2026-02-12) — Écoute l'event `knoria:rate-limited`
 * émis par l'intercepteur axios quand un endpoint renvoie HTTP 429
 * (Too Many Requests). Affiche UN SEUL toast throttlé toutes les 60 s
 * pour ne pas spammer l'utilisateur, avec un message informatif et
 * non-alarmiste (pas le banner « Reconnexion en cours » qui faisait
 * croire à Vincent qu'il y avait un bug de session).
 *
 * Contrairement au ConnectionRecoveringBanner (bandeau haut de page),
 * ce composant utilise seulement le système de toasts `sonner` déjà en
 * place, pour un feedback ponctuel et discret.
 */
import { useEffect, useRef } from "react";
import { toast } from "sonner";

const THROTTLE_MS = 60_000; // Un seul toast par minute max, quelle que soit la salve.

export default function RateLimitToast() {
  const lastShownRef = useRef(0);

  useEffect(() => {
    const onRateLimited = (e) => {
      const now = Date.now();
      // Throttle : n'affiche pas plus d'un toast toutes les THROTTLE_MS.
      if (now - lastShownRef.current < THROTTLE_MS) return;
      lastShownRef.current = now;
      const retryAfterMs = e.detail?.retryAfterMs || 60_000;
      const seconds = Math.ceil(retryAfterMs / 1000);
      toast.warning(
        "Trop de requêtes en peu de temps",
        {
          description: `Le serveur limite temporairement les requêtes. Réessaie dans ~${seconds} s. Ta session reste active.`,
          duration: 6000,
        }
      );
    };
    window.addEventListener("knoria:rate-limited", onRateLimited);
    return () => window.removeEventListener("knoria:rate-limited", onRateLimited);
  }, []);

  return null;
}
